export async function apiGetHubServer(): Promise<string> {
  const result = await fetch(`${process.env.REACT_APP_WSS_URL}/identify`);

  if (result.ok) {
    return await result.text();
  } else {
    throw result;
  }
}
